import styled from 'styled-components';

import { theme } from '../../ui/theme';

export const Required = styled.span.attrs({
    className: 'text-danger',
    children: ' *',
})`
    font-weight: ${theme.fontWeights[700]};
`;
